import jwt from "jsonwebtoken";
import cookie from "js-cookie";
export const setToken = ({ token }) => {
  try {
    const { exp } = jwt.decode(token);
    const expires = new Date(exp * 1000);
    cookie.set("token", token, { expires });
  } catch (error) {
    // useHihistorystory.push("/login");
  }
};
export const setTokenUser = (user) => {
  const data = {
    userName: user.userName,
    roleLevel: user.roleLevel,
    userId: user.id,
    agentId: user.agentId,
  };
  cookie.set("user", JSON.stringify(data));
};
export const setTokenSignalR = (token) => {
  cookie.set("tokenSignalR", token);
};
export const setRole = (token) => {
  cookie.set("role", token);
};
export const setAgentId = (agentId) => {
  cookie.set("agentId", agentId);
};
export const getTokenUser = () => {
  let user = cookie.get("user");
  return user != null ? JSON.parse(user) : null;
};
export const logout = (redirect = "/") => {
  cookie.remove("token");
  // to support logging out from all windows
  window.localStorage.setItem("logout", Date.now());
  // Router.push(`/login?r=${encodeURIComponent(redirect)}`);s
};
